import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page__content" }
const _hoisted_2 = { class: "auth" }
const _hoisted_3 = { class: "auth__container" }
const _hoisted_4 = { class: "auth__header" }
const _hoisted_5 = { class: "auth__logo" }
const _hoisted_6 = { class: "auth__version" }

import IconLogo from "@/assets/icons/IconLogo.vue";
import packageJson from "../../package.json";
import {ref} from "vue";
import IconPasswordVisible from "@/assets/icons/IconPasswordVisible.vue";
import IconPasswordHidden from "@/assets/icons/IconPasswordHidden.vue";
import {useRouter} from "vue-router";
import {LogIn} from "@/composables/auth";
import GlobalLoader from "@/components/ui/loaders/GlobalLoader.vue";
import {useStore} from "@/stores";

// Интерфейс формы пользователя
interface IUserForm {
  username: string;
  password: string;
}

// Интерфейс ошибок формы
interface IUserFormErrors {
  username: boolean;
  password: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const store = useStore();

// Текущая версия приложения из package.json.
const version: string = packageJson.version;

// Флаг. Видимость пароля в поле ввода.
const isShowPassword = ref<boolean>(false);
const toggleShowPassword = (): void => {
  isShowPassword.value = !isShowPassword.value;
};

// Список ошибок
const userFormErrors = ref<IUserFormErrors>({
  username: false,
  password: false,
});

// Форма пользователя
const userForm = ref<IUserForm>({
  username: "",
  password: ""
});

// Отправка формы
const handleSubmit = async (event: Event): Promise<void> => {
  event.preventDefault();

  isAuthStart.value = true;

  // Сброс предыдущих ошибок
  userFormErrors.value.username = false;
  userFormErrors.value.password = false;

  // Валидация полей
  if (userForm.value.username.length === 0) {
    userFormErrors.value.username = true;
  }

  if (userForm.value.password.length === 0) {
    userFormErrors.value.password = true;
  }

  if (userFormErrors.value.username || userFormErrors.value.password) {
    isAuthStart.value = false;
    return;
  }

  // Выполнение авторизации
  const loginData = await LogIn(userForm.value);

  if (loginData.status) {
    await router.push("/map-view");
  } else {
    if (loginData.code === 401) {
      store.showWarning("Неверный логин или пароль", "Проверьте правильность ввода и повторите попытку", 15000);
    } else {
      store.showWarning("Сервер временно недоступен", "Повторите попытку позднее", 15000);
    }
  }

  isAuthStart.value = false;
};

// Статус логина.
const isAuthStart = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_InputPrimary = _resolveComponent("InputPrimary")!
  const _component_ButtonAccentPrimary = _resolveComponent("ButtonAccentPrimary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(IconLogo)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "auth__title" }, " ОРАКУЛ — М ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "auth__subtitle" }, " Пожалуйста, авторизуйтесь, чтобы продолжить работу в системе ", -1))
          ]),
          _createElementVNode("form", {
            class: "auth__form form",
            role: "form",
            "aria-labelledby": "auth-title",
            onSubmit: handleSubmit
          }, [
            _createVNode(_component_InputPrimary, {
              modelValue: userForm.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userForm.value.username) = $event)),
              label: "Логин",
              error: userFormErrors.value.username,
              "aria-label": "Введите логин"
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_InputPrimary, {
              modelValue: userForm.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userForm.value.password) = $event)),
              label: "Пароль",
              error: userFormErrors.value.password,
              type: isShowPassword.value ? 'text' : 'password',
              "aria-label": "Введите пароль"
            }, {
              suffix: _withCtx(() => [
                (isShowPassword.value)
                  ? (_openBlock(), _createBlock(IconPasswordVisible, {
                      key: 0,
                      role: "button",
                      class: "password-icon",
                      onClick: toggleShowPassword
                    }))
                  : (_openBlock(), _createBlock(IconPasswordHidden, {
                      key: 1,
                      role: "button",
                      class: "password-icon",
                      onClick: toggleShowPassword
                    }))
              ]),
              _: 1
            }, 8, ["modelValue", "error", "type"]),
            _createVNode(_component_ButtonAccentPrimary, {
              size: "large",
              type: "submit",
              pressed: isAuthStart.value
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Войти ", -1)
              ]))]),
              _: 1
            }, 8, ["pressed"])
          ], 32)
        ]),
        _createElementVNode("span", _hoisted_6, " Версия " + _toDisplayString(_unref(version)), 1)
      ])
    ]),
    (isAuthStart.value)
      ? (_openBlock(), _createBlock(GlobalLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})